import { render } from "./PaymentStatusView.vue?vue&type=template&id=1bff9f82"
import script from "./PaymentStatusView.vue?vue&type=script&lang=js"
export * from "./PaymentStatusView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__